export default {
    blacklist: {
        prodTitle1: "Blacklist",
        prodContent1: "Through the customer's ID number, mobile phone number, device number, IP, face, determine whether the customer is in the blacklist library, further complete customer portrait information, reduce business risks, reduce risks of fraud, malicious deception and other behaviors.",

        prodTwoTitle1: "Introduction",
        prodContentSon1: "According to the historical data of customers' lending, consumption and behavior, the paper constructs a high-risk fraud model to provide blacklist service for enterprises.",

        prodThreeTitle1: "Advantage",
        prodThreeContentTitleSon1: "High recognition rate",
        prodThreeContentSon1: "Million-level risk control data.",

        prodThreeContentTitleSon2: "Fastest",
        prodThreeContentSon2: "Service millisecond level response.",

        prodThreeContentTitleSon3: "Authorized data sources",
        prodThreeContentSon3: "Connect with the risk control data sources of the three parties, update information timely, respond accurately and efficiently, and provide data security protection system to ensure the stability and security of data interaction.",

        prodThreeContentTitleSon4: "User stratification",
        prodThreeContentSon4: "Multi-parameter multi-dimensional output customer portrait.",
    },
    face: {
        prodTitle1: "Product advantage",

        prodContentTitleSon1: "High-precision model",
        prodContentSon1: "a million-level face training model",

        prodContentTitleSon2: "Fastest",
        prodContentSon2: "service millisecond level response",

        prodContentTitleSon3: "Robustness",
        prodContentSon3: "support accurate recognition of different expressions, different ages, complex backgrounds and light",

        prodTwoTitle1: "Application scenarios",

        prodTwoContentTitleSon1: "Financial business",
        prodTwoContentSon1: "Face recognition technology has a broad application prospect in the financial industry, which can be divided into identity verification, intelligent recognition and analysis, business innovation support and other application directions.",

        prodTwoContentTitleSon2: "Online exams",
        prodTwoContentSon2: "To further promote exam fairness, more and more universities are applying face recognition to course exams.",

        prodTwoContentTitleSon3: "Smart community",
        prodTwoContentSon3: "Face recognition is introduced into the community to help build a modern smart community and make people's urban life more intelligent.",

        prodTwoContentTitleSon4: "Transportation",
        prodTwoContentSon4: "The application of traffic QR code, electronic tag, video monitoring, traffic simulation and other services promotes the development of the transportation industry to the direction of intelligence and information.",

        prodTwoContentTitleSon5: "Government services",
        prodTwoContentSon5: "'Internet + government services', artificial intelligence technologies such as face recognition and voice search have been applied in all aspects of government affairs.",

        prodTwoContentTitleSon6: "Hotel accommodation",
        prodTwoContentSon6: "Face recognition is the basis of building an intelligent hotel ecosystem.  Based on face recognition technology, it can create an overall face brushing ecosystem from check-in to check-out.",

        prodThreeTitle1: "Product demonstration",
    },
    ocr: {
        prodTitle1: "Product advantage",

        prodContentTitleSon1: "High accuracy",
        prodContentSon1: " accurate identification of photocopy and photo information and support to determine whether it is the original",

        prodContentTitleSon2: "High concurrency",
        prodContentSon2: "support ten thousand levels of concurrency within seconds",

        prodContentTitleSon3: "Robustness",
        prodContentSon3: "support the accurate identification of multi-angle, complex background and light",

        prodTwoTitle1: "Application scenarios",

        prodTwoContentTitleSon1: "Financial business",
        prodTwoContentSon1: "Fast, accurate and efficient financial business information, shorten the operation time of each business, save the customer's original information and electronic authentication, all these can be solved by the increasingly perfect OCR technology.",

        prodTwoContentTitleSon2: "Government affairs service",
        prodTwoContentSon2: "Social informatization is accelerating, and people have a higher desire for fast and orderly information. The in-depth application of OCR technology in office automation provides a solid foundation for national organs, enterprises and institutions to realize paperless office.",

        prodTwoContentTitleSon3: "Publishing and printing",
        prodTwoContentSon3: "OCR recognition technology has been relatively mature, OCR products are widely used in news, printing, publishing, library, office automation and other industries.",

        prodThreeTitle1: "Product demonstration",
    },
    risk: {
        prodTitle1: "Product advantage",

        prodContentTitleSon1: "High recognition rate",
        prodContentSon1: "million-level risk control data",

        prodContentTitleSon2: "Fastest",
        prodContentSon2: "service millisecond level response",

        prodContentTitleSon3: "User stratification",
        prodContentSon3: "multi-parameter multi-dimensional output customer portrait",

        prodContentTitleSon4: "Robustness",
        prodContentSon4: "support accurate recognition of different expressions, different ages, complex backgrounds and light",

        prodTwoTitle1: "Application scenarios",

        prodTwoContentTitleSon1: "Financial business",
        prodTwoContentSon1: "The powerful technical advantages of intelligent risk control bring great convenience to financial institutions to identify projects, and help banks and other institutions to identify project risks and select investment. Ultimately, finance will play a role in promoting the development and upgrading of economic structure.",

        prodTwoContentTitleSon2: "Smart community",
        prodTwoContentSon2: "Access control and visitor system, identity verification system for public convenience services, video monitoring of community security.",

        prodTwoContentTitleSon3: "Traffic",
        prodTwoContentSon3: "Under the new concept of intelligent risk control, the urban traffic safety risk warning is more timely, the accident prevention and health effect is more obvious, the risk face and dangerous road management is more effective, the accident responsible unit or individual accountability is more powerful,  and the risk is controlled as far as possible before the accident.",

        prodThreeTitle1: "Product demonstration",
    },
    intelligent: {
        prodTitle1: "Product advantage",

        prodContentTitleSon1: "Lightning decision",
        prodContentSon1: "Business oriented, develop a scheme integrating strategies, rules and models, lightning deployment, rapid response, low-cost operation and lightweight operation.",

        prodContentTitleSon2: "Massive high-quality customers",
        prodContentSon2: "Massive high-quality customers: Based on our customers, online parters apps and offline business entities, we have built a multi-source, three-dimensional customer acquisition channel, which can effectively obtain millions of customers informations every day. Therefore, Seeder's Big Data Deep Mining System can provide customized and massive high-quality customers for the platform of financial institutions.",

        prodContentTitleSon3: "Accurate customers portraits",
        prodContentSon3: "Based on a large number of high-quality customers and the needs of financial business, Seeder's Technology Platform optimizes products, constructs multi-dimensional and accurate customers portraits, and realizes the quantitative analysis of the financial attributes of customers.",

        prodContentTitleSon4: "Low risk and high return",
        prodContentSon4: "On the basis of obtaining high-quality customers and their portraits, financial institutions can build corresponding financial schemes to improve the conversion efficiency from customers traffic to financial business customers, reduce the proportion of fraudulent customers and funds risk, achieve the goal of low risk and high return.",

        prodTwoTitle1: "Cooperative media platforms",

        prodThreeTitle1: "Service Cases",

        btn1: "Kwai",
        btn2: "Cheetah Mobile",
        btn3: "Bytedance",

        btn1Content: {
            tabTitle1: "Kwai",
            tabText1: "Cooperation product",

            tabTitle2: "10 months",
            tabText2: "Cooperation time",

            tabTitle3: "Facebook, Google",
            tabText3: "Cooperation media",

            tabTitle4: "$20,000 - $50,000",
            tabText4: "Daily budget",

            tabTitle5: "IN, BR",
            tabText5: "Delivery area",

            tabTitle6: "IN CPI  $0.30 - $0.39 IN RR 39%",
            tabText6: "Key data",
        },
        btn2Content: {
            tabTitle1: "Live.me",
            tabText1: "Cooperation product",

            tabTitle2: "10 months",
            tabText2: "Cooperation time",

            tabTitle3: "Facebook, Google",
            tabText3: "Cooperation media",

            tabTitle4: "$10,000 - $20,000",
            tabText4: "Daily budget",

            tabTitle5: "IN  US  SA  etc",
            tabText5: "Delivery area",

            tabTitle6: "IN CPI $0.35 - $0.40 IN RR 35%",
            tabText6: "Key data",
        },
        btn3Content: {
            tabTitle1: "Tik Tok",
            tabText1: "Cooperation product",

            tabTitle2: "8 months",
            tabText2: "Cooperation time",

            tabTitle3: "Facebook",
            tabText3: "Cooperation media",

            tabTitle4: "$20,000 - $50,000",
            tabText4: "Daily budget",

            tabTitle5: "IN",
            tabText5: "Delivery area",

            tabTitle6: "IN CPI $0.38 - $0.45 IN RR 42%",
            tabText6: "Key data",
        }
    }
};